import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CardTransaction } from 'src/app/models/card-transaction.model';
import { Card } from 'src/app/models/card.model';
import { TransactionHistoryList } from 'src/app/models/transaction-history.model';
import {
  createServerDate,
  generatePastDate
} from 'src/app/shared/utils/date.utils';
import * as fromCards from '../../reducers/cards/cards.reducer';
import * as fromDashboard from '../../reducers/dashboard/dashboard.reducer';
import { generateFutureDate } from './../../../shared/utils/date.utils';

export const selectDashboardStateFeature =
  createFeatureSelector<fromDashboard.State>(fromDashboard.dashboardFeatureKey);

export const selectCardStateFeature = createFeatureSelector<fromCards.State>(
  fromCards.cardsFeatureKey
);

export interface CardsViewModel {
  cards: Card[] | null;
  selectedCard: Card | null;
}

export interface TransactionHistoryPath {
  cardToken: string | undefined;
  memberNumber: string | undefined;
  from: string | undefined;
  to: string | undefined;
  cardType: string | undefined;
}

export interface SelectedCardModel {
  selectedCard: Card | null;
}

export interface CardTransactionHistoryModel {
  selectedCard: Card | null;
  transactionHistory: CardTransaction | null;
}

export interface CardIdModel {
  cardId: string | undefined;
}

export interface CardTransactionsDetailsModel {
  cardTransactionsDetails: TransactionHistoryList | null;
}

export const selectAllCardsViewModel = createSelector(
  selectDashboardStateFeature,
  selectCardStateFeature,
  (
    dashboardState: fromDashboard.State,
    cardsState: fromCards.State
  ): CardsViewModel => {
    return {
      cards: dashboardState.dashboard ? dashboardState.dashboard.cards : null,
      selectedCard: cardsState.selectedCard
    };
  }
);

export const selectCardTransactionHistoryPath = createSelector(
  selectCardStateFeature,
  (state: fromCards.State): TransactionHistoryPath => {
    return {
      cardToken: state.selectedCard?.cardToken,
      memberNumber: state.selectedCard?.memberNumber,
      cardType: state.selectedCard?.cardType,
      from: createServerDate(generatePastDate(-1, 3, 0).toString()),
      to: createServerDate(generateFutureDate(0, 0, 0).toString())
    };
  }
);

export const selectCardTransactionHistoryModel = createSelector(
  selectCardStateFeature,
  (state: fromCards.State): CardTransactionHistoryModel => {
    return {
      selectedCard: state.selectedCard,
      transactionHistory: state.transactionHistory
    };
  }
);

export const selectCardViewModel = createSelector(
  selectCardStateFeature,
  (state: fromCards.State): SelectedCardModel => {
    return {
      selectedCard: state.selectedCard
    };
  }
);

export const selectCardId = createSelector(
  selectCardStateFeature,
  (state: fromCards.State): CardIdModel => {
    return {
      cardId: state.selectedCard?.cardId
    };
  }
);

export const selectCardTransactionsDetails = createSelector(
  selectCardStateFeature,
  (state: fromCards.State): CardTransactionsDetailsModel => {
    return {
      cardTransactionsDetails: state.transactionHistoryList
    };
  }
);
